import React from 'react';
import './style.scss';
import Menu from '../../Components/menu';
import Footer from '../../Components/footer';
import ImgCaixa from '../../assets/images/caixa.jpg';
import ImgFgts from '../../assets/images/fgts.jpg';
import ImgGovbr from '../../assets/images/govbr.jpg';
import ImgPrefeitura from '../../assets/images/prefeitura.jpg';
import ImgInss from '../../assets/images/inss.jpg';
import ImgReceita from '../../assets/images/receita.jpg';
import ImgSimples from '../../assets/images/simples.jpg';
import ImgSintegra from '../../assets/images/sintegra.jpg';
import ScrollTop from '../../Components/ScrollTop';
function Indice(){
    return(
        <div>
            <ScrollTop />
             <Menu />
                <div className="links">
                    <div className="links__boxes">
                        <div className="links__box">
                            <img src={ImgCaixa} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgFgts} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgGovbr} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgPrefeitura} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgInss} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgReceita} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgSimples} alt="Caixa" />
                        </div>
                        <div className="links__box">
                            <img src={ImgSintegra} alt="Caixa" />
                        </div>
                    </div>
                </div>
             <Footer />
        </div>
    )
}
export default Indice;